import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class NewuserService {

  constructor(private dataService: DataService) { }

  getUsers(searchQuery) {
    return this.dataService.getRecordWithParams('/api/NewUser/getNewUser', searchQuery);
  };

  deletePendingUser(userId) {
    return this.dataService.getRecord('/api/NewUser/deletePendingUser/' + userId);
  };
  getUserNameForResellerUsers(searchQuery) {
    return this.dataService.getRecordWithParams('/api/NewUser/getUserNameForResellerUsers/', searchQuery);
  }
}
